const EVENTS = new Set(["contact_cta", "demo_start", "demo_complete", "demo_outage", "audit_example_view", "audit_pdf_download", "google_reviews_click", "contact_submit_success"]);
const OFFERS = new Set(["audit", "integration", "training", "custom-software", "other"]);

// Only fixed categories and the document language enter event metadata.
export function trackProofEvent(name, offer = "other") {
  if (!EVENTS.has(name)) return;
  try {
    window.sa_event?.(name, { offer: OFFERS.has(offer) ? offer : "other", locale: document.documentElement.lang === "fr" ? "fr" : "en" });
  } catch {
    // Measurement must never change the form or demonstration outcome.
  }
}
